import { Capitalize, iaRa, mString, pluralize } from 'lib/helpers/utility';

import Badge from 'components/shared/Badge/Badge';
import {
  APPOINTMENT_RESOURCE_OPTIONS,
  CLAIM_OPTIONS,
  EOB_OPTIONS,
  PATIENT_OPTIONS,
  PAYER_OPTIONS,
  PROVIDER_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import Actions from '../components/Actions';

export const COLUMN_DEFS = [
  {
    field: 'paid_date',
    headerName: 'Payment Date',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'check_number',
    headerName: 'Check/Trace #',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'payer_name',
    headerName: 'Payer',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'claims_length',
    headerName: 'Claims',
    cellClass: 'no-border',
    aggFunc: 'sum',
    flex: 1
  },
  {
    field: 'unallocated_amount_cents',
    headerName: 'Unallocated Amount',
    cellClass: 'no-border',
    valueFormatter: (params) => mString(params.value),
    flex: 1,
    aggFunc: 'sum'
  },
  {
    field: 'total_paid',
    headerName: 'Amount Paid',
    cellClass: 'no-border',
    valueFormatter: (params) => mString(params.value),
    flex: 1,
    aggFunc: 'sum'
  },
  {
    field: 'payment_method',
    headerName: 'Payment Method',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'status',
    headerName: 'Status',
    cellClass: 'no-border',
    flex: 1,
    cellRenderer: (params) => {
      const isGrouped = params.node.group;
      const groupedColumns = params.columnApi.getRowGroupColumns();
      const isFinalizedGrouped = groupedColumns.some((col) => col.getColId() === 'status');
      const status = params?.value;
      const colors = {
        finalized: 'success',
        pending: 'warning',
        archived: 'neutral'
      };
      const statusColor = colors[status];

      if (!isGrouped || isFinalizedGrouped) {
        return (
          <div className="flex h-full items-center">
            <Badge text={Capitalize(status)} color={statusColor} />
          </div>
        );
      }

      return null;
    }
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const INITIAL_FILTERS = {
  date: {
    type: 'date-range',
    title: 'Created Date',
    icon: 'calendar-mono'
  },
  eob: EOB_OPTIONS,
  patient: { ...PATIENT_OPTIONS, allowed_operators: ['is any of', 'is not', 'is'] },
  payer: { ...PAYER_OPTIONS, allowed_operators: ['is any of', 'is not', 'is'] },
  provider: PROVIDER_OPTIONS,
  appointment_resource: APPOINTMENT_RESOURCE_OPTIONS,
  claim: CLAIM_OPTIONS,
  check_number: {
    title: 'Check/Track number',
    queryKey: 'eob_check_numbers.options',
    icon: 'credit-card-mono'
  },
  // npi: {
  //   title: 'Prov/Bill NPI',
  //   queryKey: 'npi.options',
  //   placeholder: 'Search provider/bill npi',
  //   icon: 'credit-card-mono'
  // },
  status: {
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: EOB_SWITCH_ITEMS.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'eob_statuses.options',
    title: 'Status',
    placeholder: 'Select status',
    icon: 'status-mono',
    allowed_operators: ['is any of', 'is not', 'is']
  }
};

export const EOB_SWITCH_ITEMS = [
  {
    label: 'Finalized',
    value: 'finalized'
  },
  {
    label: 'Pending',
    value: 'pending'
  },
  {
    label: 'Archived',
    value: 'archived'
  }
];
export const ACTION_CONFIRMATION_MESSAGES = (claims, type) => {
  const claimNumbers = iaRa(claims)
    .map((claim) => claim)
    .join(', ');

  const claimsMessage = claimNumbers ? (
    <>
      {pluralize('Claim', claims.length)} [{claimNumbers}] will be unallocated.
    </>
  ) : (
    <p className="text-danger-500">No claims selected</p>
  );

  const warningMessage = <p className="text-danger-500">This action cannot be reverted.</p>;

  return {
    delete: {
      title: `Delete ${type?.toUpperCase()}`,
      message: (
        <>
          <p>{`Are you sure you want to delete this ${type?.toUpperCase()}?`}</p>
          <p>{`All claims related to this ${type?.toUpperCase()} will be unallocated.`}</p>
          {warningMessage}
        </>
      )
    },
    unAllocate: {
      title: `Unallocate ${type?.toUpperCase()}`,
      message: (
        <>
          <p>{`Are you sure you want to unallocate this ${type?.toUpperCase()}?`}</p>
          {claimsMessage}
          {warningMessage}
        </>
      )
    },
    archive: {
      title: `Archive ${type?.toUpperCase()}`,
      message: (
        <>
          <p>{`Are you sure you want to archive this ${type?.toUpperCase()}?`}</p>
        </>
      )
    },
    unarchive: {
      title: `Unarchive ${type?.toUpperCase()}`,
      message: (
        <>
          <p>{`Are you sure you want to unarchive this ${type?.toUpperCase()}?`}</p>
        </>
      )
    }
  };
};
